<template>
    <div>
        <div class="card mb-5 mb-3">
            <div class="card-header">
                <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
                        danh sách nhân viên</span></h3>
            </div>
            <div class="card-body">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Tên:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Tên nhân viên..." v-model="search.cTenNhanVien" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Tên tài khoản:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-input clearable placeholder="Tên tài khoản ..." v-model="search.cTenTaiKhoan" />
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Trạng thái:</label>
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                                    <el-option label="Tất cả" value="-1" selected></el-option>
                                    <el-option label="Hoạt động" value="1" selected></el-option>
                                    <el-option label="Đã xóa" value="0" selected></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                        <label>Trạng thái nhân viên:</label>
                        <el-row :gutter="10">
                            <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                                <el-select placeholder="Tất cả" v-model="search.nMaTrangThai">
                                    <el-option label="Tất cả" value="-1" selected></el-option>
                                    <el-option v-for="item in employeeStatus" :key="item.nMaTrangThai"
                                        :label="item.cTenTrangThai" :value="item.nMaTrangThai" selected></el-option>
                                </el-select>
                            </el-col>
                            <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                                        class="fa fa-search"></i></el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
        </div>

        <div class="card data-table mb-5 mb-xl-10">
            <div class="card-header py-3">
                <div class="body-function">
                    <div class="col-md-6">
                        <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd"
                            data-bs-toggle="modal" data-bs-target="#modal_hotline" :disabled="!handleCheckPerms('sys:employees:delete')">
                            <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
                            <span class="btn-inner--text">&nbsp;Thêm nhân viên </span>
                        </el-button>
                    </div>
                    <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
                </div>
            </div>
            <div class="card-body">
                <div class="col-md-12 tbl">
                    <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%"
                        height="100%" fit stripe highlight-current-row>
                        <el-table-column prop="nMaNhanVien" label="Mã" width="100" align="center"></el-table-column>
                        <el-table-column prop="cTenNhanVien" label="Tên nhân viên" min-width="150"
                            header-align="center">
                        </el-table-column>
                        <el-table-column prop="nMaTaiKhoan" label="Mã tài khoản" align="center" width="150">
                            <template #default="scope">
                                {{ scope.row.nMaTaiKhoan }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="cTenTaiKhoan" label="Tên tài khoản" width="150" align="center">
                            <!--  <template #default="scope">
                                <el-tag type="danger" effect="dark" v-if="scope.row.cTenTaiKhoan == 'Khan cap'"
                                    :size="size">Khẩn cấp</el-tag>
                                <el-tag type="success" effect="dark" v-if="scope.row.cTenTaiKhoan == 'Doi song xa hoi'"
                                    :size="size">Đời sống xã hội</el-tag>
                            </template> -->
                        </el-table-column>
                        <el-table-column prop="dNgayTao" label="Ngày tạo" width="120">
                            <template #default="scope">
                                {{ momentDate(scope.row.dNgayTao) }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="Trạng thái nhân viên" width="120" align="center">
                            <template #default="scope">
                                <el-tag
                                    :type="scope.row.nMaTrangThai == 1 ? 'primary' : [2, 3].includes(scope.row.nMaTrangThai) ? 'warning' : scope.row.nMaTrangThai == 1? 'info': 'danger'"
                                    size="small"
                                    v-if="employeeStatus.filter(val => {return scope.row.nMaTrangThai == val.nMaTrangThai}).length > 0">
                                    {{employeeStatus.filter(val => {return scope.row.nMaTrangThai == val.nMaTrangThai})[0].cTenTrangThai}}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="Trạng thái" width="120" align="center">
                            <template #default="scope">
                                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
                            </template>
                        </el-table-column>
                        <!-- Button hành động -->
                        <el-table-column width="150" label="Hành động" align="center">
                            <template #default="scope">

                                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('sys:employees:edit')"
                                    @click="handleOpenEdit(scope.row)" data-bs-toggle="modal"
                                    data-bs-target="#modal_hotline">
                                    <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                                </el-button>    

                                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0 || !handleCheckPerms('sys:employees:delete')"
                                    v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                                    <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="col-12 py-2 pagination" style="justify-content: end">
                <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
                    :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]"
                    :page-size="tableData.pageSize" layout="total, sizes, prev, pager, next, jumper"
                    :total="tableData.totalSize">
                </el-pagination>
            </div>
        </div>

        <div class="modal fade" id="modal_hotline" ref="hotlineModalRef" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered mw-650px">
                <div class="modal-content">
                    <!--begin::Modal header-->
                    <div class="modal-header" id="modal_hotline_header">
                        <!--begin::Modal title-->
                        <h2 class="fw-bolder">{{ !operation ? "Thêm nhân viên " : "Cập nhật nhân viên " }}</h2>
                        <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
                            @click="handleClose">
                            <span class="svg-icon svg-icon-1">
                                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
                            </span>
                        </div>
                        <!--end::Close-->
                    </div>
                    <!--end::Modal header-->
                    <div class="modal-body">
                        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px"
                            class=" d-flex flex-column">
                            <el-form-item label="Tên nhân viên" prop="cTenNhanVien">
                                <el-input v-model="formData.cTenNhanVien" />
                            </el-form-item>
                            <el-form-item label="Tài khoản" prop="nMaTaiKhoan">
                                <el-select filterable v-model="formData.nMaTaiKhoan">
                                    <el-option v-for="item in users" :key="item.nMaTaiKhoan"
                                        :label="item.cHoTen" :value="item.nMaTaiKhoan" selected></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="Quầy" prop="nMaQuay">
                                <el-select filterable v-model="formData.nMaQuay">
                                    <el-option v-for="item in booths" :key="item.nMaQuay"
                                        :label="item.cTenQuay" :value="item.nMaQuay" selected></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="operation" label="Trạng thái nhân viên" prop="nMaTrangThai">
                                <el-select filterable v-model="formData.nMaTrangThai">
                                    <el-option v-for="item in employeeStatus" :key="item.nMaTrangThai"
                                        :label="item.cTenTrangThai" :value="item.nMaTrangThai" selected></el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="modal-footer">
                        <div class="btn-group">
                            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Thêm</el-button>
                            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                                @click="handleSave">Lưu</el-button>
                            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Booth, Employee, EmployeeStatus, Hotlines, Users } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { ElMessage } from "element-plus";
import { CookieComponent } from "@/assets/ts/components";

export default {
    name: 'employee',
    data() {
        return {
            perms: CookieComponent.get("permissions") ? JSON.parse(CookieComponent.get("permissions")) : [], 
            search: {
                cTenNhanVien: "",
                nMaTaiKhoan: "",
                cTenTaiKhoan: "",
                nTinhTrang: "-1",
            },
            pageRequest: {
                columnFilters: {},
                pageSize: 30,
                pageNum: 1
            },
            formData: {
                cTenNhanVien: "",
                nMaNhanVien:null,
                nMaQuay:null,
                nMaTaiKhoan: null,
                nMaTrangThai:null,
                nTinhTrang:null
            },
            rules: {
                cTenNhanVien: [{ required: true, message: "Xin vui lòng điền tên nhân viên", trigger: "blur" }],
                nMaTaiKhoan: [
                    { required: true, message: "Xin vui lòng điền số điện thoại", trigger: "blur" },
                ],
                nMaTrangThai: [{ required: true, message: "Xin vui lòng chọn trạng thái", trigger: "blur" }],
                nMaQuay: [{ required: true, message: "Xin vui lòng nhập địa chỉ", trigger: "blur" }],
            },
            tableData: {
                content: [{}]
            },
            isLoading: false,
            modalVisible: false,
            operation: false,
            iframeURL: "",
            openIframe: false,
            isSearchLoading: false,
            store: useStore(),
            employeeStatus: [],
            booths: [],
            users:[]
        }
    },
    methods: {
        handleChangePageNum(val) {
            this.pageRequest.pageNum = val
            this.handleFindPage()
        },
        handleChangePageSize(val) {
            this.pageRequest.pageSize = val
            this.handleFindPage()
        },
        handleOpenAdd() {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = false
            this.formData = {}
        },
        handleOpenEdit(val) {
            this.$refs.formData.resetFields()
            this.modalVisible = true
            this.operation = true
            this.formData = Object.assign({}, val)
        },
        handleClose() {
            this.$refs.formData.resetFields()
            this.modalVisible = false
            hideModal(this.$refs.hotlineModalRef)
        },
        handleDelete(val) {
            this.$confirm("Bạn có muốn xóa nhân viên này không?", "Xác nhận", {
                confirmButtonText: "Xác nhận",
                cancelButtonText: "Hủy",
                type: "warning",
            })
                .then(() => {
                    this.store.dispatch(Employee.deleteEmployee, val).then(res => {
                        if (res.code == 200) {
                            ElMessage({ message: "Xóa nhân viên thành công", type: "success" });
                            this.handleFindPage()
                        } else {
                            ElMessage({ message: res.msg, type: "error" });
                        }
                    }).catch((error) => {
                        ElMessage({ message: "Xóa nhân viên thất bại", type: "error" });
                    })
                }).catch(() => {

                })
        },
        handleFindPage() {
            this.pageRequest.columnFilters = {
                cTenNhanVien: {value:this.search.cTenNhanVien},
                cTenTaiKhoan: {value:this.search.cTenTaiKhoan},
                nTinhTrang: {value:this.search.nTinhTrang},
                nMaTrangThai: {value:this.search.nMaTrangThai},
            }
            this.store.dispatch(Employee.findPageEmployee, this.pageRequest).then(res => {
                if (res.code == 200) {
                    this.tableData = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm nhân viên thất bại", type: "error" });
            })
        },
        handleSave() {
            this.$refs.formData.validate((valid) => {
                if (valid)
                    this.$confirm("Bạn có muốn lưu nhân viên này không?", "Xác nhận", {
                        confirmButtonText: "Xác nhận",
                        cancelButtonText: "Hủy",
                        type: "warning",
                    })
                        .then(() => {
                            if(this.formData.nMaTrangThai == null || this.formData.nMaTrangThai == undefined){
                                this.formData.nMaTrangThai = 5
                            }
                            const data = Object.assign({}, this.formData);
                            this.store.dispatch(Employee.saveEmployee, data).then(res => {
                                if (res.code == 200) {
                                    ElMessage({ message: this.operation ? "Cập nhật nhân viên thành công" : "Thêm nhân viên thành công", type: "success" });
                                    this.handleClose()
                                    this.handleFindPage()
                                }
                                else {
                                    ElMessage({ message: res.msg, type: "error" });
                                }
                            }).catch((error) => {
                                ElMessage({ message: this.operation ? "Cập nhật nhân viên thất bại" : "Thêm nhân viên thât bại", type: "error" });
                            })

                        }).catch(() => {

                        })
            })
        },
        handleGetEmployeeStatus() {
            this.store.dispatch(EmployeeStatus.getEmployeeStatusList).then(res => {
                if (res.code == 200) {
                    this.employeeStatus = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm trạng thái nhân viên thất bại", type: "error" });
            })
        },
        handleGetBooth(){
            this.store.dispatch(Booth.getBoothList).then(res => {
                if (res.code == 200) {
                    this.booths = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm danh sách quầy thất bại", type: "error" });
            })
        },
        handleGetUser(){
            this.store.dispatch(Users.getUserByRoleId, 8).then(res => {
                if (res.code == 200) {
                    this.users = res.data
                }
            }).catch((error) => {
                ElMessage({ message: "Tìm danh sách tài khoản thất bại", type: "error" });
            })
        },
        momentDate(val) {
            return val ? moment(val).format("DD/MM/YYYY") : ""
        },
        handleCheckPerms(val){
            return this.perms.includes(val)
        }
    },
    mounted() {
        this.handleGetUser()
        this.handleGetBooth()
        this.handleGetEmployeeStatus()
        this.handleFindPage()
    }
};
</script>
<style lang="scss"></style>